import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { QUALITY_ISSUE_TYPE, type QualityIssue, RISK_ISSUE_TYPE } from '../../../../../shared/issuesV2';
import { useCreateQualityDispute } from '../../../../hooks/api/issues/useCreateQualityDispute';
import * as IssuesV2Store from '../../../../redux/issuesV2';
import { ModalReportQualityDispute } from '../../../modals/ModalReportQualityDispute';
import { useIssueDetailsModals } from '../IssueDetailsModalsContext';
import type { QualityDisputeReasonsType } from '../../../../../shared/model-typings/qualitydisputes';

import styles from '../DisputeFooter.module.less';

const DISPUTABLE_ISSUE_TYPES = new Set<string>([
  QUALITY_ISSUE_TYPE.OutdatedDependency,
  RISK_ISSUE_TYPE.RiskAbandonware,
  RISK_ISSUE_TYPE.RiskEmptyPackage,
]);

export const QualityIssueDisputeFooter: VoidFunctionComponent = () => {
  const issueDetails = useSelector(IssuesV2Store.selectors.getIssueDetails) as QualityIssue;
  const { qualityDisputeModal, isAnyModalOpen } = useIssueDetailsModals();
  const { mutateAsync, isPending, reset } = useCreateQualityDispute();

  if (!issueDetails || !DISPUTABLE_ISSUE_TYPES.has(issueDetails.type)) {
    return null;
  }

  const onSubmit = async (comment: string, reason: QualityDisputeReasonsType) => {
    await mutateAsync({ issueId: issueDetails.id, reason, comment });
    qualityDisputeModal.onClose();
  };

  const onHide = () => {
    reset();
    qualityDisputeModal.onClose();
  };

  return (
    <>
      <footer className={styles.footer}>
        Found a mistake?
        {' '}
        <button
          type="button"
          className={styles.footerButton}
          onClick={() => !isAnyModalOpen && qualityDisputeModal.onOpen()}
          disabled={isAnyModalOpen}
        >
          Report a data issue with this quality issue.
        </button>
      </footer>
      <ModalReportQualityDispute
        isPending={isPending}
        onHide={onHide}
        onSubmit={onSubmit}
        show={qualityDisputeModal.isOpen}
      />
    </>
  );
};
